import React from "react";
import Link from "next/link";

export default function Footer({ lang = 'vn' }: { lang?: 'vn' | 'en' }) {
  return (
    <>
<div className="footer _0-tp" data-wf--footer--variant="base">
 <div className="section-cta">
  <div className="cta-cardfrfrdr-2">
   <div className="cta-wrapper">
    <div className="assistant-text-block-main-4">
     <h3 className="assitance-heading-3 card" data-w-id="20ac9fbd-0d94-554a-9c51-bfa7f9e47df3">
      <strong>
       {lang === 'vn' ? 'Tuyển dụng nhân lực số đa nhiệm của bạn ngay hôm nay' : 'Hire Your Digital Force Multiplier Today'}
      </strong>
     </h3>
     <p className="paragraph-57 asitance-para" data-w-id="20ac9fbd-0d94-554a-9c51-bfa7f9e47df6">
      {lang === 'vn' ? 'Đặt lịch demo nhanh và xem cách video AI mới nhất thúc đẩy năng suất cao hơn và giữ an toàn cho mọi địa điểm — suốt ngày đêm.' : 'Book a quick demo and see how the latest in video AI drives higher productivity and keeps every site secure — around the clock.'}
     </p>
     <a className="button-tertiary w-button" data-w-id="20ac9fbd-0d94-554a-9c51-bfa7f9e47df8" href="mailto:contact@keeneyeai.site">
      {lang === 'vn' ? 'Yêu cầu Demo' : 'Request a Demo'}
     </a>
    </div>
    <div className="assistant-steps-2">
     <img alt="" className="assistant-steps-img-2" loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/68a73b2944e72d4ebe927e45_Group%20195.svg"/>
    </div>
   </div>
  </div>
  <div className="page-footer alt-img">
   <div className="container-small">
    <div className="footer-top flex grid home-footer-top" data-w-id="cc6cfe74-ace1-20d7-6e01-c425e8837393">
     <div className="footer-images-holder mb-16 hidden home-image-holder">
      <img alt="KeenEye Logo" className="footer-logo award-logos" loading="lazy" src="/assets/img/keeneye-horizontal-white.png" style={{ height: "38px", width: "auto" }}/>
      <div className="vertical-line-2">
      </div>
      <img alt="" className="footer-logo award-logos" loading="lazy" src="https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/611fd1a10fe431f6f2f36034_logo-forbes-cloud100-rising-star-%402x.png"/>
     </div>
     <div className="div-block-96 footer-home-div">
      <div className="footer-images-holder mb-16 footer-home-holder">
       <a aria-label="keeneye" className="footer-link w-inline-block" href="/">
        <img alt="KeenEye Logo" className="footer-brand" loading="lazy" src="/assets/img/keeneye-horizontal-white.png" style={{ height: "38px", width: "auto" }}/>
       </a>
      </div>
      <div className="footer-title-button-2 left-aligned footer-title video-button-lightbox">
       {lang === 'vn' ? 'KeenEye biến camera thành các tác nhân chủ động bảo vệ con người, tối ưu hóa hoạt động và mang lại kết quả có thể đo lường.' : 'KeenEye transforms cameras into active agents that protect people, optimize operations, and drive measurable outcomes.'}
      </div>
      <div className="social-grid">
       <a className="w-inline-block" href="https://play.google.com/store/apps/details?id=ai.keeneye.dashboard&amp;hl=en_US&amp;gl=US" target="_blank">
        <img alt="" className="social-icon" loading="lazy" src="https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68ab621d7f6ef175306d18f6_6244a9b955a454c42e2a27d7_spot-ai-google-play%402x.avif"/>
       </a>
       <a className="w-inline-block" href="https://apps.apple.com/us/app/keeneye-dashboard/id1609067120" target="_blank">
        <img alt="App Store Icon" className="social-icon-2" loading="lazy" src="https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/6244a9c16f5d9a5edff42415_spot-ai-app-store%402x.png"/>
       </a>
      </div>
      <div className="footer-sub-wrap _0-tm footer-sub-home">
      </div>
     </div>
     <div className="div-block-96 tm footer-div-third">
      <div className="footer-images-holder mb-16 footer-home-holder">
       <a aria-label="forbes" className="link-block-8 right-padding-40px footer-link-block w-inline-block" href="https://keeneyeai.site/post/keeneye-named-one-of-forbes-cloud-100-rising-stars-for-2021">
        <img alt="" className="footer-logo award-logos auto footer-link-logo" loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6b90d_Frame%201707480289%20(1).png"/>
       </a>
       <a className="link-block-8 right-padding-40px footer-link-block w-inline-block" href="https://keeneyeai.site/post/keeneye-named-one-of-the-top-40-intelligent-applications-for-2021">
        <img alt="" className="footer-logo award-logos _90 footer-link-logo" height="90" loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6b90e_Frame%201707480291%20(1).png" width="72"/>
       </a>
       <div className="footer-div-last">
        <img alt="" className="footer-logo award-logos _90 footer-last-logo" loading="lazy" src="https://cdn.prod.website-files.com/689cc11ced7b87fef7d6a908/689cc11ced7b87fef7d6b910_Frame%201707480292%20(1).png"/>
       </div>
      </div>
     </div>
    </div>
    <div className="w-layout-grid footer-grid footer-home-grid" data-w-id="cc6cfe74-ace1-20d7-6e01-c425e88373ac">
     <div className="footer-bottom footer-home-button" id="w-node-cc6cfe74-ace1-20d7-6e01-c425e88373ad-be728c90">
      <div className="div-block-97 footer-div-button">
       <a className="secondary-link-2 smaller footer-secondary" href="/privacy">
        {lang === 'vn' ? 'Quyền riêng tư' : 'Privacy'}
       </a>
       <a className="secondary-link-2 smaller footer-secondary" href="/terms-of-use">
        {lang === 'vn' ? 'Điều khoản sử dụng' : 'Terms of use'}
       </a>
       <a className="secondary-link-2 smaller footer-secondary" href="/evaluation-terms-of-use">
        {lang === 'vn' ? 'Điều khoản đánh giá' : 'Evaluation Terms of use'}
       </a>
      </div>
     </div>
     <div className="div-block-87 mobile-only footer-div-five" id="w-node-cc6cfe74-ace1-20d7-6e01-c425e88373b5-be728c90">
      <div className="footer-column pr-0 la footer-home-custom">
       <div className="footer-title home-footer-ttile">
        {lang === 'vn' ? 'SẢN PHẨM' : 'PRODUCT'}
       </div>
       <a className="footer-link new footer-home-link" href="/ai-security-guard">
        {lang === 'vn' ? 'Bảo vệ AI' : 'AI Security Guard'}
       </a>
       <a className="footer-link new footer-home-link" href="/ai-operations-assistant">
        {lang === 'vn' ? 'Trợ lý vận hành AI' : 'AI Operations Assistant'}
       </a>
       <a className="footer-link new footer-home-link" href="/iris">
        Iris
       </a>
      </div>
      <div className="footer-column last new footer-home-custom">
       <div className="footer-title home-footer-ttile">
        {lang === 'vn' ? 'TÀI NGUYÊN' : 'RESOURCES'}
       </div>
       <a className="footer-link new footer-home-link" href="/customer-stories">
        {lang === 'vn' ? 'Câu chuyện Khách hàng' : 'Customer Stories'}
       </a>
       <a className="footer-link new footer-home-link" href="/blog">
        Blog
       </a>
       <a className="footer-link new footer-home-link" href="/virtual-events">
        {lang === 'vn' ? 'Sự kiện Ảo' : 'Virtual Events'}
       </a>
       <a className="footer-link new footer-home-link" href="/product-tours">
        {lang === 'vn' ? 'Hướng dẫn Sản phẩm' : 'Product Tours'}
       </a>
       <a className="footer-link new footer-home-link" href="/documents">
        {lang === 'vn' ? 'Tài liệu' : 'Documents'}
       </a>
       <a className="footer-link new footer-home-link" href="/become-a-partner-old">
        {lang === 'vn' ? 'Trở thành Đối tác' : 'Become a Partner'}
       </a>
      </div>
      <div className="footer-column last new footer-home-custom">
       <div className="footer-title home-footer-ttile">
        {lang === 'vn' ? 'GIẢI PHÁP' : 'SOLUTIONS'}
       </div>
       <a className="footer-link new footer-home-link" href="/solutions/industrials">
        {lang === 'vn' ? 'Sản xuất & Kho bãi' : 'Manufacturing & Warehousing'}
       </a>
       <a className="footer-link new footer-home-link" href="/solutions/construction">
        {lang === 'vn' ? 'Xây dựng' : 'Construction'}
       </a>
       <a className="footer-link new footer-home-link" href="/solutions/multi-location-retail">
        {lang === 'vn' ? 'Bán lẻ Chuỗi' : 'Multi-Location Retail'}
       </a>
       <a className="footer-link new footer-home-link" href="/solutions/car-washes">
        {lang === 'vn' ? 'Rửa xe' : 'Car Washes'}
       </a>
       <a className="footer-link new footer-home-link" href="/solutions/healthcare">
        {lang === 'vn' ? 'Y tế' : 'Healthcare'}
       </a>
       <a className="footer-link new footer-home-link" href="/solutions/education">
        {lang === 'vn' ? 'Giáo dục' : 'Education'}
       </a>
      </div>
      <div className="footer-column pr-0 la footer-home-custom">
       <div className="footer-title home-footer-ttile">
        {lang === 'vn' ? 'CÔNG TY' : 'COMPANY'}
       </div>
       <a className="footer-link new footer-home-link" href="/about-us">
        {lang === 'vn' ? 'Giới thiệu' : 'About'}
       </a>
       <a className="footer-link new footer-home-link" href="/careers">
        {lang === 'vn' ? 'Tuyển dụng' : 'Careers'}
       </a>
       <a className="footer-link new footer-home-link" href="/support">
        {lang === 'vn' ? 'Liên hệ Hỗ trợ' : 'Contact Support'}
       </a>
       <a className="footer-link new footer-home-link" href="/contact-sales">
        {lang === 'vn' ? 'Liên hệ Kinh doanh' : 'Contact Sales'}
       </a>
       <a className="nav-letter-link is-newsletter-footer w-inline-block" href="/newsletter">
        <img alt="" className="image-nav-letter-link" loading="eager" src="https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/6a01d12afdcd99beb64acfa3_TheEdge-Dark%20(1).svg"/>
        <div className="text-nav-letter-link">
         {lang === 'vn' ? 'Bản tin' : 'Newsletter'}
        </div>
       </a>
      </div>
     </div>
     <div className="footer-column last new m-hidden footer-home-custom">
      <div className="footer-column pr-0 la footer-home-custom hide">
       <div className="footer-title home-footer-ttile">
        PRODUCT
       </div>
       <a className="footer-link new footer-home-link" href="/ai-security-guard">
        AI Security Guard
       </a>
       <a className="footer-link new footer-home-link" href="/ai-operations-assistant">
        AI Operations Assistant
       </a>
       <a className="footer-link new footer-home-link" href="/iris">
        Iris
       </a>
      </div>
     </div>
     <div className="footer-column last new footer-home-custom hide">
      <div className="footer-title home-footer-ttile">
       SOLUTIONS
      </div>
      <a className="footer-link new footer-home-link" href="/solutions/industrials">
       Manufacturing &amp; Warehousing
      </a>
      <a className="footer-link new footer-home-link" href="/solutions/construction">
       Construction
      </a>
      <a className="footer-link new footer-home-link" href="/solutions/retail">
       Retail
      </a>
      <a className="footer-link new footer-home-link" href="/solutions/car-washes">
       Car Washes
      </a>
      <a className="footer-link new footer-home-link" href="/solutions/healthcare">
       Healthcare
      </a>
      <a className="footer-link new footer-home-link" href="/solutions/education">
       Education
      </a>
      <a className="footer-link new footer-home-link" href="/solutions/government">
       Government
      </a>
     </div>
     <div className="footer-column last new footer-home-custom hide">
      <div className="footer-title home-footer-ttile">
       RESOURCES
      </div>
      <a className="footer-link new footer-home-link" href="/customer-stories">
       Customer Stories
      </a>
      <a className="footer-link new footer-home-link" href="/blog">
       Blog
      </a>
      <a className="footer-link new footer-home-link" href="/virtual-events">
       Virtual Events
      </a>
      <a className="footer-link new footer-home-link" href="/product-tours">
       Product Tours
      </a>
      <a className="footer-link new footer-home-link" href="/documents">
       Documents
      </a>
      <a className="footer-link new footer-home-link" href="/become-a-partner">
       Become a Partner
      </a>
      <a className="footer-link new footer-home-link" href="#">
      </a>
     </div>
     <div className="footer-column pr-0 la footer-home-custom hide">
      <div className="footer-title home-footer-ttile">
       COMPANY
      </div>
      <a className="footer-link new footer-home-link" href="/about-us">
       About
      </a>
      <a className="footer-link new footer-home-link" href="/careers">
       Careers
      </a>
      <a className="footer-link new footer-home-link" href="/support">
       Contact Support
      </a>
      <a className="footer-link new footer-home-link" href="/contact-sales">
       Contact Sales
      </a>
      <a className="nav-letter-link is-newsletter-footer w-inline-block" href="/newsletter">
       <img alt="" className="image-nav-letter-link" loading="eager" src="https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/6a01d12afdcd99beb64acfa3_TheEdge-Dark%20(1).svg"/>
       <div className="text-nav-letter-link">
        Newsletter
       </div>
      </a>
     </div>
    </div>
     <div className="secondary-link-2 smaller footer-secondary" style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "24px", color: "rgba(255, 255, 255, 0.5)" }}>
      <div>{lang === 'vn' ? '© 2026 KeenEye, Inc. Bảo lưu mọi quyền.' : '© 2026 KeenEye, Inc. All rights reserved.'}</div>
      <div style={{ fontSize: "0.85rem" }}>
        Email: <a href="mailto:contact@keeneyeai.site" style={{ color: "#a5b4fc", textDecoration: "underline" }}>contact@keeneyeai.site</a> | Hotline: <a href="tel:0919896562" style={{ color: "#a5b4fc" }}>0919896562</a> | {lang === 'vn' ? 'Địa chỉ' : 'Address'}: 123 Anywhere St., District 1, HCMC, Vietnam
      </div>
     </div>
   </div>
  </div>
 </div>
</div>

    </>
  );
}
